import React from 'react';
import { motion } from 'framer-motion';
export function TopBanner() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // The message that scrolls across. The emoji sits at the end of the message.
  const Message = () => <span className="inline-flex items-center gap-2 px-8 whitespace-nowrap" data-id="element-206">
      <span className="font-bold" data-id="element-207">Oferta de lanzamiento</span>
      <span data-id="element-208">— 67% OFF</span>
      <span aria-hidden="true" data-id="element-209">✨</span>
    </span>;
  return <a href="#oferta" onClick={handleScroll} aria-label="Oferta de lanzamiento — 67% OFF" className="block w-full overflow-hidden bg-primary-dark text-white py-2.5 text-sm font-medium hover:bg-primary transition-colors" data-id="element-210">
      <motion.div className="flex w-max whitespace-nowrap" animate={{
      x: ['-50%', '0%']
    }} transition={{
      duration: 18,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-211">
        {/* Duplicated for a seamless, continuous loop */}
        {Array.from({
        length: 8
      }).map((_, i) => <Message key={i} data-id="element-212" />)}
      </motion.div>
    </a>;
}